import React from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

interface ScreenHeaderProps {
    onClick?: (() => void) | undefined;
    text: string;
}

export default function FormHeader(props: ScreenHeaderProps) {
    return (
        <>
            <Box sx={{ display: "flex", justifyContent: "space-between", position: "relative", pb: 2 }}>
                <Typography sx={{ fontWeight: "bold" }}>{props.text}</Typography>
            </Box>
        </>
    );
}
